module.exports = "/_next/static/images/avatar-frame-tier-2--simple-554755b8074fce75f86b4c8379c0c1e5.png";